// extracted by mini-css-extract-plugin
module.exports = {"LocaleSwitcher":"LocaleSwitcher_LocaleSwitcher__2JXvR","LocaleSwitcherCurrentValue":"LocaleSwitcher_LocaleSwitcherCurrentValue__T3XIF"};